import { forwardRef, Icon, IconProps } from "@chakra-ui/react";
export default forwardRef<IconProps, "svg">((props, svgRef) => (
  <Icon
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={18}
    fill="none"
    viewBox="0 0 16 18"
    ref={svgRef}
    {...props}
  >
    <g
      fill="currentColor"
      clipPath="url(#collection-offer_svg__collection-offer_svg__clip0_17756_288070)"
    >
      <path d="M4.426 6.184h-.118a.897.897 0 00-.772.885c0 .493.399.885.89.885h.11a.897.897 0 00.772-.885.883.883 0 00-.882-.885zm4.121 4.892h-.12a.897.897 0 00-.77.884c0 .494.398.885.89.885h.11a.897.897 0 00.771-.885.883.883 0 00-.881-.884zm.81-2.551l-4.24.851.167.834 4.24-.851-.167-.834z" />
      <path d="M16 7.307c0-.561-.22-1.097-.61-1.488L9.826.239A.806.806 0 009.251 0H2.78a.816.816 0 00-.814.817v1.829H.882c-.492 0-.882.4-.882.884v7.086c0 .238.093.46.263.63l6.07 6.082c.213.213.467.383.747.502a2.243 2.243 0 001.764-.001c.28-.118.534-.288.746-.501l5.062-5.079c.432-.433.67-1.02.67-1.624 0-.477-.153-.936-.424-1.327l.492-.494c.39-.4.61-.935.61-1.488v-.009zm-2.612 3.684l-5.062 5.078a.765.765 0 01-.17.12.582.582 0 01-.203.042.582.582 0 01-.203-.043l-.06-.034s-.076-.051-.11-.085l-5.808-5.827V4.406H7.59l5.808 5.827a.535.535 0 010 .749l-.009.009zm.848-3.344l-.466.468-5.198-5.214a.878.878 0 00-.627-.264H3.587V1.625h5.325l5.324 5.342a.491.491 0 01.136.34.46.46 0 01-.144.34h.008z" />
    </g>
    <defs>
      <clipPath id="collection-offer_svg__collection-offer_svg__clip0_17756_288070">
        <path fill="currentColor" d="M0 0h16v18H0z" />
      </clipPath>
    </defs>
  </Icon>
));
